var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    { staticClass: "gh-list-item" },
    [
      _c("GenerationHistoryListItemHead", {
        attrs: {
          "service-name-key": _vm.serviceNameKey,
          "project-name": _vm.item.project_name,
          datetime: _vm.item.request_datetime_ts,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "gh-list-item__body" }, [
        _c("div", { staticClass: "gh-list-item__left", style: _vm.leftStyle }, [
          _c(
            "div",
            {
              staticClass:
                "gh-list-item__preview gh-list-item__preview--design",
            },
            _vm._l(_vm.previewImages, function (image, idx) {
              return _c("img", {
                key: `${_vm.item.project_id}-img-${idx}`,
                staticClass: "gh-list-item__thumb",
                class: { "gh-dnd-source": _vm.canDrag },
                attrs: {
                  src: _vm.imageUrl(image),
                  alt: "",
                  draggable: _vm.canDrag ? "true" : "false",
                },
                on: {
                  dragstart: function ($event) {
                    return _vm.onImageDragStart($event, image)
                  },
                  dragend: _vm.onDragEnd,
                },
              })
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "gh-list-item__view-all",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$emit("view-all", _vm.item.project_id)
                },
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(_vm.viewAllKey, { count: _vm.item.total_count })
                  ) +
                  "\n      "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "gh-list-item__right" },
          [
            _c("GenerationHistoryMetaRows", {
              attrs: {
                fields: _vm.inlineFields,
                variant: "inline",
                "can-drag-fields": _vm.canDrag,
                "drag-field-keys": _vm.missionDragKeys,
                "row-key-prefix": `design-board-${_vm.item.project_id}`,
              },
              on: {
                "field-drag-start": _vm.onMissionDragStart,
                "field-drag-end": _vm.onDragEnd,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }